import React from "react";
import { ExternalLink } from "components/ExternalLink";
import { CopyableCodeLine } from "onboarding/components/NumberedStep";
import {
  APPOPTICS_INSTALLER_URL_BASE,
  KB_URL_BASE,
} from "onboarding/constants";
import { track } from "utils/track";
const INSTALLER = "DotNetAgent_Setup.exe";
const INSTALLER_URL = `${APPOPTICS_INSTALLER_URL_BASE}/dotnet/${INSTALLER}`;
const KNOWLEDGEBASE_URL = `${KB_URL_BASE}/apm_tracing/dotnet/install/`;

const dotnetInstructions = props => {
  const { agentRecorderToken, serviceName, selectedOperatingSystem } = props;
  if (selectedOperatingSystem !== "windows") return null;
  return [
    {
      precedingContent: (
        <div>
          The installer we provide will manage downloading and configuring the
          agent. If you’d prefer to do this manually or need more help,{" "}
          <ExternalLink href={KNOWLEDGEBASE_URL}>
            check out our documentation
          </ExternalLink>.
        </div>
      ),
      title: "Download the .NET agent installer:",
      content: (
        <p onClick={_ => track("Clicked .Net APM installer URL")}>
          <a href={INSTALLER_URL}>{INSTALLER_URL}</a>
        </p>
      ),
    },
    {
      title: "Stop IIS by running via the command line:",
      content: (
        <div onClick={_ => track("Copied the .Net APM stop script")}>
          <CopyableCodeLine> iisreset /STOP </CopyableCodeLine>
        </div>
      ),
    },
    {
      title: "Run the installer and provide this service key when requested:",
      content: (
        <div onClick={_ => track("Copied the .Net APM service key")}>
          <CopyableCodeLine>
            {agentRecorderToken}:{serviceName}
          </CopyableCodeLine>
        </div>
      ),
    },
    {
      title: "Restart all application pools:",
      content: (
        <div onClick={_ => track("Copied the .Net APM restart script")}>
          <CopyableCodeLine>iisreset /restart</CopyableCodeLine>
          <p>In a few seconds, the agent will be connected to AppOptics.</p>
        </div>
      ),
    },
  ];
};

export default dotnetInstructions;
